"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageRegistry = void 0;
const accounts_page_1 = require("./accounts.page");
const login_page_1 = require("./auth/login.page");
const migrate_page_1 = require("./auth/migrate.page");
const collection_history_page_1 = require("./collection.history.page");
const pole_loading_page_1 = require("./dashboard/pole.loading.page");
const pole_status_page_1 = require("./dashboard/pole.status.page");
const comed_esri_page_1 = require("./externalPages/comed.esri.page");
const forgot_password_page_1 = require("./forgot.password.page");
const form_edit_new_page_1 = require("./form.edit.new.page");
const form_edit_page_1 = require("./form.edit.page");
const form_list_page_1 = require("./form.list.page");
const import_page_1 = require("./import/import.page");
const logout_page_1 = require("./logout.page");
const missing_page_1 = require("./missing.page");
const org_search_page_1 = require("./org.search.page");
const photomeasure_page_1 = require("./photomeasure.page");
const root_page_1 = require("./root.page");
const tag_map_page_1 = require("./tag.map.page");
const topological_editor_page_1 = require("./topological.editor.page");
const pages = [
    // !! Internal Pages !!
    { config: root_page_1.RootPageConfig, page: root_page_1.RootPage },
    // Authentication
    { config: login_page_1.LoginPageConfig, page: login_page_1.LoginPage },
    { config: logout_page_1.LogoutPageConfig, page: logout_page_1.LogoutPage },
    { config: forgot_password_page_1.ForgotPasswordPageConfig, page: forgot_password_page_1.ForgotPasswordPage },
    { config: migrate_page_1.SSOMigratePageConfig, page: migrate_page_1.SSOMigratePage },
    // Listed (order matters)
    { config: tag_map_page_1.TagMapPageConfig, page: tag_map_page_1.TagMapPage },
    { config: form_list_page_1.FormListPageConfig, page: form_list_page_1.FormListPage },
    { config: accounts_page_1.AccountsPageConfig, page: accounts_page_1.AccountsPage },
    { config: import_page_1.CSVFileImportPageConfig, page: import_page_1.CSVFileImportPage },
    // Form
    { config: form_edit_page_1.FormEditPageConfig, page: form_edit_page_1.FormEditPage },
    { config: form_edit_new_page_1.FormEditNewPageConfig, page: form_edit_new_page_1.FormEditNewPage },
    // Collection
    { config: photomeasure_page_1.PhotoMeasurePageConfig, page: photomeasure_page_1.PhotoMeasurePage },
    { config: collection_history_page_1.CollectionHistoryPageConfig, page: collection_history_page_1.CollectionHistoryPage },
    // Org search
    { config: org_search_page_1.OrgSearchConfig, page: org_search_page_1.OrgSearchPage },
    // Dashboard
    { config: pole_status_page_1.DashPoleStatusConfig, page: pole_status_page_1.DashPoleStatus },
    { config: pole_loading_page_1.DashPoleLoadingConfig, page: pole_loading_page_1.DashPoleLoading },
    // Topological editor page
    { config: topological_editor_page_1.TopologicalEditorPageConfig, page: topological_editor_page_1.TopologicalEditorPage },
    // Misc
    { config: missing_page_1.MissingPageConfig, page: missing_page_1.MissingPage },
    // !! External Pages !!
    { config: comed_esri_page_1.ComEdEsriPageConfig },
];
exports.PageRegistry = {
    pages,
    getConfig(name) {
        for (const page of pages) {
            if (page.config.name === name) {
                return page.config;
            }
        }
        return null;
    },
};
//# sourceMappingURL=page.registry.js.map